import { makeStyles } from '@material-ui/styles'

export default makeStyles(() => ({
    coverImg: {
        width: '100%',
        backgroundSize: 'contain',
        backgroundAttachment: 'fixed',
        backgroundPosition: 'top',
        backgroundRepeat: 'no-repeat',
        position: 'absolute',
        paddingBottom: 'calc(100% / (5/2))',
    },
}))
